import React, { useState, useEffect } from "react";
import axios from "axios";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import { baseurl, imageUrl } from "../../../Baseurl"; // Ensure baseurl is defined
import Swal from "sweetalert2"; // Import SweetAlert2
import { Link, useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';


const EditBanner = () => {
  const { id } = useParams(); // Get the banner ID from the URL params
  const [bannerImage, setBannerImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [heading, setHeading] = useState("");
  const [actionUrl, setActionUrl] = useState("");
  const [status, setStatus] = useState("active");
  const navigate = useNavigate(); 
  
  // Fetch banner details on component load
  useEffect(() => {
    const fetchBannerDetails = async () => {
      try {
        const response = await axios.get(`${baseurl}getBannerDetailById/${id}`);
        const { data } = response.data;
        // Set the fields with the fetched data
        setHeading(data.heading);
        setActionUrl(data.action_url);
        setStatus(data.status);
        setBannerImage(data.banner_image ? `${imageUrl}banners/${data.banner_image}` : null);
      } catch (error) {
        console.error("Error fetching banner details:", error);
        Swal.fire("Error", "Failed to fetch banner details.", "error");
      }
    };

    fetchBannerDetails();
  }, [id]);

  // Handle file selection and validation
  const handleFile = (file) => {
    if (file && file.type.startsWith("image/")) {
      setBannerImage(URL.createObjectURL(file));
      setSelectedFile(file);
    } else {
      Swal.fire("Invalid file", "Please upload a valid image file.", "error");
    }
  };

  // Handle form submission for update
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedFile && !bannerImage) {
      Swal.fire("No File Selected", "Please upload an image first.", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("banner", selectedFile);
    formData.append("heading", heading);
    formData.append("action_url", actionUrl);
    formData.append("status", status);
    // formData.append("banner_type", "Full Banner");

    try {
      const response = await axios.put(`${baseurl}update-banner/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      Swal.fire("Success", "Banner updated successfully!", "success").then(() => {
        navigate(-1); 
      });
    } catch (error) {
      Swal.fire("Update Failed", "Something went wrong. Try again!", "error");
      console.error("Update error:", error);
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Website Banners</h4>
          </div>

 
          <div className="row p-2">
            <div className="col-md-8 bg-white">
              {/* Heading Input */}
              <div className="mb-3 text-start">
                <label className="form-label">Heading</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Banner Heading"
                  value={heading}
                  onChange={(e) => setHeading(e.target.value)}
                />
              </div>

              {/* Action URL Input */}
              <div className="mb-3 text-start">
                <label className="form-label">Action URL</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Banner Action URL"
                  value={actionUrl}
                  onChange={(e) => setActionUrl(e.target.value)}
                />
              </div>

              {/* Status Input */}
              <div className="mb-3 text-start">
                <label className="form-label">Status</label>
                <select
                  className="form-control"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              {/* Drop Area */}
              <div
                className="drop-area"
                onDrop={(e) => {
                  e.preventDefault();
                  const file = e.dataTransfer.files[0];
                  handleFile(file);
                }}
                onDragOver={(e) => e.preventDefault()}
                onClick={() => document.getElementById("fileInput").click()}
              >
                {bannerImage ? (
                  <img src={bannerImage} alt="Banner Preview" className="preview-image" />
                ) : (
                  <p>Drag & drop an image here, or click to select</p>
                )}
              </div>

              {/* Hidden File Input */}
              <input
                type="file"
                id="fileInput"
                accept="image/*"
                className="banimg"
                onChange={(e) => handleFile(e.target.files[0])}
                style={{ display: "none" }}
              />

              <div className="text-end mb-3">
                <button className="btn btn-primary mt-3" onClick={handleSubmit}>
                  Update Banner
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBanner;
